var exports = {
  "m": "BaseChangeNicknameModal.module__clearButton___Uld4cm",
};

module.exports = exports;
